import React, { useState } from "react";
import "../AdminNewPage/Style/NewAttendancePage.css";
import { COLOR } from "../../../Config/Color";
import CurrentDayAttendance from "./Component/CurrentDayAttendance";
import SingleEmployeeAttendance from "./Component/SingleEmployeeAttendance";
import MonthlyAttendanceHistory from "./Component/MonthlyAttendanceHistory";
import MainLayout from "../../../../layouts/MainLayout";

const NewAttendancePage = () => {
  const [activeTab, setActiveTab] = useState("Current Day Attendance");
  const [weekOn, setWeekOn] = useState(false);

  const tabs = ["Current Day Attendance", "Single Employee", "Monthly History"];
  return (
    <MainLayout>
      <div className="page-wrapper">
        <div className="content">
          <div className="newattendance-container">
            <div className="w-100 d-flex justify-content-between align-items-center">
              <h1 className="my-2 text-start fs-24 text-dark">
                Attendance Sheet
              </h1>
              <div style={{ display: "flex", alignItems: "center" }}>
                {/* <TbRefresh size={18} />*/}
                {/* <p style={{ marginLeft: 10, marginRight: 10 }}>
                  Pull to refresh the page for new data
                </p> */}
              </div>
            </div>
            <div className="flex items-center justify-between border-b border-gray-300 px-10 pt-1 bg-white rounded-lg shadow-sm">
              {/* Tabs */}
              <div className="d-flex align-items-center gap-3 py-2">
                {tabs.map((tab) => (
                  <button
                    key={tab}
                    onClick={() => setActiveTab(tab)}
                    className={` font-bold bold  pb-3 ${activeTab === tab
                      ? "text-blue-600 border-b-2 border-blue-600"
                      : "text-[#78829D]" // Custom color for inactive tab
                      }`}
                  >
                    {tab}
                  </button>
                ))}
              </div>

              {/* Toggle Switch */}
              <div className="flex items-center">
                <label className="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    checked={weekOn}
                    onChange={() => setWeekOn(!weekOn)}
                    className="sr-only peer"
                  />

                  <div className="w-12 h-6 bg-gray-300 rounded-full peer-checked:bg-blue-600 relative flex items-center">
                    {/* Toggle Thumb */}
                    <div
                      className={`absolute top-1/2 transform -translate-y-1/2 w-5 h-5 ${weekOn ? "" : "bg-white"} rounded-full transition ${weekOn ? "left-6" : "left-1"
                        }`}
                      style={weekOn ? { background: "#1b84ff" } : {}}
                    ></div>
                  </div>
                </label>
                <span
                  style={{
                    color: "#343741",
                    fontSize: "14px",
                    //fontFamily: "Inter",
                    fontWeight: "400",
                    marginLeft: "10px",
                  }}
                >
                  {weekOn ? "Week On" : "Week Off"}
                </span>
              </div>
            </div>
            <div style={{ marginTop: "20px", width: "100%" }}>
              {activeTab === "Current Day Attendance" && (
                <CurrentDayAttendance data={weekOn} />
              )}
              {activeTab === "Single Employee" && (
                <SingleEmployeeAttendance data={weekOn} />
              )}
              {activeTab === "Monthly History" && (
                <MonthlyAttendanceHistory data={weekOn} />
              )}
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default NewAttendancePage;
